<section class="page-wrap animated fadeIn">
  <header class="pattern-header">
    Carlton Family
  </header>
  <div class="products flex-column mb-5">
    <div class="row landing-container">
      <div class="col-12">
        <p class="h6-regular text-center">
          It’s been said that farming, specifically dairy farming, gets in your blood, and it’s hard to get it out. For
          us, that is entirely true. <strong>Louie Carlton started the dairy in 1946</strong>, and we have milked cows
          every day since.<strong>The result is a third generation - and counting</strong> - dairy farm, with every
          family member contributing in one way or another to the farm’s survival and success.
        </p>
      </div>
    </div>
    <div class="row landing-container">
      @for (item of family(); track $index) {
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 p-0 animated fadeInDown">
        <div class="product-card">
          <img src="/assets/images/landing/about/family/{{item.img}}" alt="Image of {{item.title}}" />
          <div class="product-card__container">
            <div>
              <span class="title">
                {{item.title}}
              </span>
              <p class="description mt-3" [innerHTML]="item.description"></p>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</section>